import { createStyles, Grid, LinearProgress, makeStyles, Paper, Typography } from "@material-ui/core";
import React from "react";
import { Redirect, useHistory, useParams } from "react-router-dom";
import {
  useCompleteUploadDocumentsTaskMutation,
  useGetUploadDocumentsTaskDetailsQuery,
  useListMyModuleDocumentsQuery,
} from "../../../api/rtk/MeApi";
import { routesPaths } from "../../../Routes";
import DefaultButtons from "../../common/buttons/DefaultButtons";
import TranslatedMessage from "../../translations/TranslatedMessage";
import CompleteTaskButton from "./CompleteTaskButton";
import DocumentsManager from "./DocumentsManager";
import TaskDetails from "./TaskDetails";
import { useQuery } from "../../../utils/UseQuery";

const useStyles = makeStyles((theme) =>
  createStyles({
    section: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(3),
    },
  })
);


const UploadDocumentsForm = () => {
  const taskId = useQuery().get("taskId");
  const { examSessionId, moduleId } = useParams<{ examSessionId: string; moduleId: string }>();
  const { data: taskDetails, isLoading: isQueryLoading } = useGetUploadDocumentsTaskDetailsQuery(
    { taskId: taskId ?? "", examSessionId, moduleId },
    { skip: !taskId || !examSessionId || !moduleId }
  );
  const { data: documents } = useListMyModuleDocumentsQuery({ moduleId }, { skip: !moduleId });
  const [completeTask, { isLoading: isCompletingTask }] = useCompleteUploadDocumentsTaskMutation();

  const history = useHistory();
  const classes = useStyles();

  if (!taskId || !examSessionId || !moduleId) {
    return <Redirect to={routesPaths.root()} />;
  }

  const handleCompleteTask = () => {
    completeTask({ taskId, moduleId, examSessionId })
      .unwrap()
      .then(() => history.push(routesPaths.root()));
  };
  const handleClose = () => history.push(routesPaths.root());

  const isCompleteDisabled =
    isQueryLoading ||
    !documents?.length ||
    isCompletingTask ||
    taskDetails?.isTaskCompleted ||
    taskDetails?.isTaskPastDeadline;

  return (
    <Grid container item direction="column" xs={12} sm={12} md={12} lg={10} xl={8}>
      <Grid container item direction="row">
        <Grid container item direction="column" xs={12} sm={6}>
          <Typography variant="h5">
            <TranslatedMessage id="uploadDocumentsTask.header" />
          </Typography>
        </Grid>

        <Grid container item direction="row" justify="flex-end" xs={12} sm={6}>
          <DefaultButtons
            isDeleteButtonVisible={false}
            isSaveButtonVisible={false}
            additionalButtons={<CompleteTaskButton onClick={handleCompleteTask} disabled={isCompleteDisabled} />}
            onClose={handleClose}
          />
        </Grid>
      </Grid>

      <Paper className={classes.section} elevation={2}>
        {isQueryLoading || !taskDetails ? (
          <LinearProgress variant="query" />
        ) : (
          <TaskDetails taskDetails={taskDetails} />
        )}
        {isQueryLoading ? (
          <LinearProgress variant="query" />
        ) : (
          <DocumentsManager
            moduleId={moduleId}
            documents={documents ?? []}
            readonly={taskDetails?.isTaskCompleted || taskDetails?.isTaskPastDeadline}
          />
        )}
      </Paper>
    </Grid>
  );
};

export default UploadDocumentsForm;
